<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div>
      <div class="map">

        <h3 class="header"> {{ t('modals.google_maps.pick_point_label') }} </h3>

        <GoogleMap
          :api-key="apiKey"
          :center="center"
          :zoom="7"
          style="width:100%;  height: 500px;"
          @click="mark"
        >
          <Marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            @click="center=m.position"

            :options="{ position: m.position}"
          >
          </Marker>
        </GoogleMap>

        <div class="manual-input-container">
          <div class="input-group">
            <input 
              type="number" 
              v-model="userLat" 
              placeholder="Latitude" 
              step="any"
              class="form-control"
            />
            <input 
              type="number" 
              v-model="userLng" 
              placeholder="Longitude" 
              step="any"
              class="form-control"
            />
            <button 
              class="btn btn-secondary" 
              @click="handleUserInputtedLatLng(userLat, userLng)"
            >
              {{ t('modals.google_maps.set_coordinates_label') }}
            </button>
          </div>
        </div>
       
        <button class="btn btn-primary button" :disabled="lat == '' || lng == ''" @click="closeModal()"> {{ t('modals.google_maps.pick_point_label') }} </button>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import GlobalEventBus from '../services/GlobalEventBus'
  import { inject, onMounted, ref, reactive } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'
  import i18n from '@utils/i18n'

  const { t } = i18n.global
  const apiKey = inject('apiKey')
  
  let center = ref({ lat: 45.508, lng: -73.587 })
  let markers = reactive([])
  let lat = ''
  let lng = ''
  let userLat = ref(null)
  let userLng = ref(null)

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  onMounted(() => {
    if (props.params.pointData && props.params.pointData.training_center && props.params.pointData.training_center.location_lat && props.params.pointData.training_center.location_long) {
      center.value = {
        lat: parseFloat(props.params.pointData.training_center.location_lat),
        lng: parseFloat(props.params.pointData.training_center.location_long)
      }

      markers.push({ position: center })
    } else if (props.params.pointData.country) {
      center.value = {
        lat: parseFloat(props.params.pointData.country.lat),
        lng: parseFloat(props.params.pointData.country.lng)
      }
    } else if (props.params.pointData.entity) {
      center.value = {
        lat: parseFloat(props.params.pointData.entity.lat),
        lng: parseFloat(props.params.pointData.entity.lng)
      }

      // TODOO: think we should refactor all of this to handle entities and not just a TC or country or etc...

      markers.push({ position: center })
    } 
    else {
      geolocate()
    }
  })

  function closeModal () {
    let position = {
      lat: lat,
      lng: lng
    }

    GlobalEventBus.dispatch('coordinates', position)

    emit("close")
  }

  function mark (event) {
    // Handle both Google Maps events and direct lat/lng values
    if (event.latLng) {
      // Google Maps event
      lat = event.latLng.lat()
      lng = event.latLng.lng()
    } else {
      // Direct lat/lng values
      lat = event.lat
      lng = event.lng
    }

    center.value = {
      lat: lat,
      lng: lng
    }

    markers.pop()        
    markers.push({ position: center })
  }

  function handleUserInputtedLatLng(lat, lng) {
    if (isValidCoordinates(lat, lng)) {
      mark({ lat: parseFloat(lat), lng: parseFloat(lng) })
    } else {
      alert('Please enter valid coordinates:\n- Latitude must be between -90 and 90\n- Longitude must be between -180 and 180')
    }
  }

  function isValidCoordinates(lat, lng) {
    if (!lat || !lng) return false
    const latNum = parseFloat(lat)
    const lngNum = parseFloat(lng)
    return !isNaN(latNum) && !isNaN(lngNum) && 
           latNum >= -90 && latNum <= 90 && 
           lngNum >= -180 && lngNum <= 180
  }

  const geolocate = async () => {
    // use built in navigator to get current location
    navigator.geolocation.getCurrentPosition(position => {
      center.value = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }

      markers.push({ position: center })
    })
  }
</script>

<style>
  .header {
    /* display: inline-block; */
    padding: 10px;
  }
  .map {
    text-align: center;
  }
  .button {
    text-align: right;
    /* margin: 10px; */
    /* padding: 10px; */
  }
  .manual-input-container {
    margin: 10px 0;
    padding: 0 10px;
  }
  .input-group {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }
  .input-group input {
    width: 120px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>
